import Axios from 'axios';
import { parseResult } from '../helpers';
import { BASE_URL } from '../../constants';

const BASE_API = '/api/v2/whitelabel-ott';

export const getWhitelabelClient = async domain => {
  const res = await Axios.get(`${BASE_URL}${BASE_API}/${domain}`);
  return parseResult(res);
};

export default null;
